import React, { ElementRef, useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { createBrowserHistory } from 'history';
import { EventService } from '../../models/event-service';
import { ServiceRegistry } from '../../models/service-registry';
import EventTile from '../eventtile/eventtile';

import CreatableSelect from 'react-select/creatable';
import ContentLoader from 'react-content-loader'
import { Incident, IncidentGroup, Product, EventType } from '../../proptype';
import ReactTooltip from "react-tooltip";
import { ConfigContext } from "../../App";
import { components as selectComponents } from 'react-select';
import { SubscriptionService } from '../../models/subscription-service';
import { BsoMapping } from '../../models/mapping-service';
import parse from 'html-react-parser';
import { IMS_EVENT, OMEGA_ENV, SUBMENU, SHOW_CHATBOT,DARK_LAUNCH,ALLOWLIST_USERS } from '../../constants';
import EmptyMyEventsMessage from '../emptymyeventsmessage/emptymyeventsmessage';
import MyEventsToggle from '../myeventstoggle/myeventstoggle';
import Spinner from '../spinner/spinner';
import Banner from '../banner/banner';
import OMEGA from '../../omega';
import { clearPageState, filterOngoingCanceledMaitenaceEvents, HideFooter, Subscribed, setMyEventsPref, MY_EVENTS_PREF_KEY, resolveMyEventsPref } from '../../utils';
import GenericError from '../genericerror/genericerror';
import Navigation from '../navigation/navigation';

import { useButtonRegistry } from "../../ButtonRegistryContext";
import useKeyboardNavigation from './chatbot/KeyboardNavigationHandler';
import 'react-chatbot-kit/build/main.css';
// import { useChatbot } from "./chatbot/ChatbotControllerContext";

export default function Home(props:any) {
  // const { openChatWithWorkflow = (workflowName?: string) => {} } = useChatbot() || {};
  
  const { triggerButtonClick,getButtonRef,onButtonRegistered = (workflowName: string) => {} } = useButtonRegistry() || {};
// const { getButtonRef, onButtonRegistered } = useButtonRegistry();
  const eventDefaultValue = {
    element: "All Events",
    type: "Button",
    action: "click",
    widget: {
      name: "personalization",
      type: "panel"
    },
    feature: "personalization tab"
  }

  function omega_capture(element: any, widget_name: any, widget_type: any) {
    OMEGA.init().updateAndTrack("event", [{
      ...eventDefaultValue,
      element: element,
      widget: {
        name: widget_name,
        type: widget_type
      },
    }]);
  }

  const MyLoader = (props: any) => (
    <ContentLoader
      speed={2}
      width={'100%'}
      height={100}
      backgroundColor="#f3f3f3"
      foregroundColor="#bcb8b8"
      style={{ marginTop: "10px" }}
      {...props}
    >
      <rect x="0" y="0" rx="5" ry="5" width="70" height="70" />
      <rect x="80" y="17" rx="4" ry="4" width="100%" height="13" />
      <rect x="80" y="40" rx="3" ry="3" width="100%" height="10" />
    </ContentLoader>
  );

  const histroyAPI = useHistory()
  const dropdownRef = useRef<any>(null);
  const appliedMyEventsDefaultRef = useRef(false);
  const [events, setEvents] = useState<IncidentGroup[]>([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cloudEvents, setCloudEvents] = useState<any[]>([]);
  const [isMobile, setIsMobile] = useState<boolean>(false)
  const [currentCloudEvents, setcurrentCloudEvents] = useState<any[]>([]);
  const [subscriptions, setSubscriptions] = useState<any[]>([]);
  const [selfSubscription, setSelfSubscription] = useState<any>();
  const [loadingSubscription, setLoadingSubscription] = useState(false);
  const [subscriptionError, setSubscriptionError] = useState(false);
  const [isMyEvents, setIsMyEvents] = useState(false);
  const [isMyEventsLoading, setIsMyEventsLoading] = useState(false);
  const [myEventsDataReady, setMyEventsDataReady] = useState(false);
  const [preferMyEvents, setPreferMyEvents] = useState(false);
  const [myEvents, setMyEvents] = useState<any[]>([]);
  const [myEventsByType, setEventsByType] = useState<IncidentGroup[]>([]);
  const [myCurrentCloudEvents, setMyCurrentCloudEvents] = useState<IncidentGroup[]>([]);
  const [myCloudEvents, setMyCloudEvents] = useState<any[]>([]);
  const [entitledProducts, setEntitledProducts] = useState<any[]>();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isFilterRequest, setIsFilterRequest] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState(false);
  const [mounted, setMounted] = useState(true);
  const [hasNewUpdate, setHasNewUpdate] = useState(false);
  const [openEvent, setOpenEvent] = useState(false);
  const [navState, setNavState] = useState(0);
  const [navEventExpand, setNavEventExpand] = useState(false);
  const [bsoMapping, setBsoMapping] = useState<any[]>([]);
  const [allProducts, setAllProducts] = useState({
    products: [],
    offerings: []
  });
  const [statusMessage, setStatusMessage] = useState('');
  const locales = useContext(ConfigContext).appConfig.languageData;
  const updateMenu = useContext(ConfigContext).updateMenu;

  const {eventId}: any = useParams();

  const [loggedIn, setLoggedIn] = useState(false);
  const [isUserAllowedForDarkLaunch, setIsUserAllowedForDarkLaunch] = useState(false);
  const [tooltipExpanded, setTooltipExpanded] = useState(false);

  // Initialize custom keyboard navigation for chatbot
  useKeyboardNavigation('.react-chatbot-kit-chat-container');

  // Handle Escape key for tooltip dismissal
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        ReactTooltip.hide();
        setTooltipExpanded(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleResize = () => {
    if (window.matchMedia("only screen and (max-width: 1000px)").matches) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  };

  const handleClickMyEvents = () => {
    if (window.adobeIMS?.isSignedInUser()) {
      setMyEventsPref(MY_EVENTS_PREF_KEY, "myevents");
    }
    setPreferMyEvents(true);
    OMEGA.init().updateAndTrack("event", [{
      ...eventDefaultValue,
      element: "My Events",
    }]);
    if (!myEvents?.length) {
      setLoadingSubscription(true)
    }
    setIsMyEvents(true);
    if (isExpanded) {
      setIsExpanded(false);
    }
  };

  const handleClickAllEvents = () => {
    if (window.adobeIMS?.isSignedInUser()) {
      setMyEventsPref(MY_EVENTS_PREF_KEY, "all");
    }
    setPreferMyEvents(false);
    setLoadingSubscription(false)
    setIsMyEvents(false);
    OMEGA.init().updateAndTrack("event", [{
      ...eventDefaultValue,
      element: "All Events",
    }]);
    if (isExpanded) {
      setIsExpanded(false);
    }
  };

  const serviceRegistry: ServiceRegistry = ServiceRegistry.init();
  const eventService: EventService = EventService.init();
  eventService.setLocales(locales);
  const subscriptionService: SubscriptionService = SubscriptionService.init();
  const bsoMappingService: BsoMapping = BsoMapping.init();

  useEffect(() => {
    if (!myEventsDataReady || appliedMyEventsDefaultRef.current) {
      return;
    }
    appliedMyEventsDefaultRef.current = true;
    if (preferMyEvents && window.adobeIMS?.isSignedInUser() && !isMyEventsRecommended()) {
      // Nothing to show in My Events by default - fall back to All Events silently.
      // Only applies to the initial/default resolution, never to an explicit manual toggle.
      setPreferMyEvents(false);
      setIsMyEvents(false);
    } else {
      setIsMyEvents(preferMyEvents);
    }
  }, [myEventsDataReady, preferMyEvents]);

  useEffect(() => {
    if (hasNewUpdate) {
      loadEventData();
      loadMyEventsData(subscriptions, selfSubscription, entitledProducts);
      if (dropdownRef.current?.state?.value?.length) {
        onChange(dropdownRef.current.state.value)
      }
      setHasNewUpdate(false);
    }
  }, [hasNewUpdate])

  useEffect(() => {
    if (openEvent && !loading && typeof eventId === 'string') {
      const _element = document.querySelector(`.id-${eventId}`);
      if (_element) {
        _element.classList.add('active');
        setTimeout(() => {
          _element.scrollIntoView({
            behavior: 'smooth'
          });
        }, 200)
        setOpenEvent(false);
      }
    }
  }, [openEvent, loading]);

  useEffect(() => {
    updateMenu('Overview');

    window.addEventListener("resize", handleResize);
    localStorage.removeItem('filterObj');
    setIsMobile(!!window.matchMedia("only screen and (max-width: 1000px)").matches);

    if(window.location.hash.includes("myevents")){
      setIsMyEvents(true);
    }

    if (window.adobeIMS) {
      getAllData();
      checkUserLoggedIn();
    } else {
      document.addEventListener(IMS_EVENT, () => {
        getAllData();
        checkUserLoggedIn();
      });
    }

    eventService.registerForUpdate(() => {
      setHasNewUpdate(true);
    });

    return () => {
      setMounted(false);
      window.removeEventListener('resize', handleResize);
      document.removeEventListener(IMS_EVENT, getAllData);
    }
  }, []);

  function getAllData() {
    SUBMENU.forEach((cloud: any) => {
      if (cloud.path !== '/') {
        let cloudName = cloud.path.replace("/cloud", "");
        if (window.location.pathname.includes(cloudName)) {
          histroyAPI.push(window.location.pathname.replace(cloudName, `/cloud${cloudName}`))
          return;
        }
      }
    });
    if(window.location.pathname.includes("nav")){
      setNavState(1);
    }
    if(window.location.pathname.includes("myevents")){
      handleClickMyEvents();
    }

    let hierarchy_web = "";
    if (window.location.hash) {
      hierarchy_web = `home:notification:${window.location.hash}`
    }
    else {
      hierarchy_web = `home`
    }
    OMEGA.init().updateAndTrack('page', {
      hierarchy: hierarchy_web,
      name: "Home - Adobe System Status",
      url: encodeURIComponent(window.location.href),
      type: "home",
      env: OMEGA_ENV
    });

    if (window.location.hash) {
      histroyAPI.push(window.location.pathname);
    }

    appliedMyEventsDefaultRef.current = false;
    setPreferMyEvents(resolveMyEventsPref());
    setIsMyEvents(false);

    let state: any = histroyAPI?.location?.state;
    let safe: boolean = !!state?.page;
    if (safe) {
      clearPageState(createBrowserHistory());
    }

    if (window.adobeIMS?.isSignedInUser()) {
      subscriptionService.clearMyEventsContextCache();
    }

    const [servicePromise, productPromise]: any = [serviceRegistry.fetch(), eventService.fetch()];
    const myEventsPromise = window.adobeIMS?.isSignedInUser()
      ? subscriptionService.fetchMyEventsContext(serviceRegistry, safe).catch((err: any) => {
          omega_capture(`Error fetching subscription context: ${err?.message || err}`, 'home', 'error');
          return null;
        })
      : Promise.resolve(null);

    if (window.adobeIMS?.isSignedInUser()) {
      setLoadingSubscription(true);
    }

    Promise.all([servicePromise, productPromise, myEventsPromise])
      .then((results) => {
        if (mounted) {
          window.scrollTo(0, 0);
          const context = results[2];
          if (context) {
            let eventSubscription = context.eventSubscription,
              extractedSubscription = context.selfSubscriptions,
              entitlements = context.entitlements;

            if (entitlements?.length) {
              setEntitledProducts(entitlements);
            }
            if (eventSubscription?.length) {
              setSubscriptions(eventSubscription);
            }
            setSelfSubscription(extractedSubscription);

            loadMyEventsData(eventSubscription, extractedSubscription, entitlements);
          }
          setMyEventsDataReady(true);
          setLoadingSubscription(false);
          setIsMyEventsLoading(false);

          loadEventData();
          setLoading(false);
        }
      })
              .catch((error: any) => {
          console.error('Error in service promises in loadEventData in fetching:', error);
          omega_capture(
            `Error in service promises in loadEventData fetching: ${error.message || error.toString()}`,
            "personalization",
            "error"
          );
          setMyEventsDataReady(true);
          setLoading(false);
          setLoadingSubscription(false);
          setIsMyEventsLoading(false);
          setError(true);
        });

    // Check for pending quick actions after login
    const pendingAction = sessionStorage.getItem('pendingQuickAction');
    if (pendingAction && window.adobeIMS?.isSignedInUser()) {
      sessionStorage.removeItem('pendingQuickAction');
      // Add a small delay to ensure the component is fully loaded
      setTimeout(() => {
        executeQuickAction(pendingAction);
      }, 1000);
    }

    // IMS's redirect lands back on the site root rather than the page the user was
    // on, so restore it ourselves the same way pendingQuickAction is restored above.
    const pendingReturnPath = sessionStorage.getItem('pendingReturnPath');
    if (pendingReturnPath && window.adobeIMS?.isSignedInUser()) {
      sessionStorage.removeItem('pendingReturnPath');
      histroyAPI.push(pendingReturnPath);
    }
  }

  // Recomputes the My Events state from the given subscription context. Extracted so it can be
  // called both on initial load (with the freshly-fetched context) and on every background poll
  // refresh (with the already-loaded subscription state) - previously only the "All Events" state
  // was recomputed on refresh, leaving My Events frozen at whatever it was on initial page load.
  function loadMyEventsData(eventSubscription?: any[], extractedSubscription?: any[], entitlements?: any[]) {
    // No early return on empty inputs: incidentsCloud()/getOnGoingEventsByCloud() already fall
    // back to an "available" placeholder per cloud when there are no matching incidents, so
    // calling through with empty arrays keeps myCloudEvents populated instead of leaving it at
    // its initial [] - which otherwise renders the top cloud-tile row completely blank in My
    // Events mode for a user with zero entitlements/subscriptions.
    const myEventsPromiseResponse = eventService.getMyEvents(eventSubscription || [], extractedSubscription || [], entitlements || []);
    setEventsByType(filterOngoingCanceledMaitenaceEvents(eventService.getOnGoingEventsByType(undefined, undefined, undefined, myEventsPromiseResponse)));
    setMyCurrentCloudEvents(eventService.getOnGoingEventsByCloud(undefined, undefined, undefined, myEventsPromiseResponse));
    setMyEvents(myEventsPromiseResponse);
    setMyCloudEvents(eventService.incidentsCloud(myEventsPromiseResponse, eventSubscription, extractedSubscription, entitlements));
  }

  function loadEventData() {
    const onGoingEvents: IncidentGroup[] = filterOngoingCanceledMaitenaceEvents(eventService.getOnGoingEventsByType());
    const eventsByCloud: any = eventService.incidentsCloud();
    const ongoingCloudEvents: any = eventService.getOnGoingEventsByCloud();
    const productsAndOfferings: any = serviceRegistry.getProductsAndOfferings();
    setAllProducts(productsAndOfferings);
    setEvents(onGoingEvents);
    setCloudEvents(eventsByCloud);
    setcurrentCloudEvents(ongoingCloudEvents);
     let incident = eventService.getIncident(eventId);
      if (incident) {  
          setOpenEvent(true);
      }
  }

  function redirectCloud(cloudId: any) {
    let currentMenu = SUBMENU.filter((menu: any) => menu.id === cloudId);
    if (currentMenu.length) {
      updateMenu(currentMenu[0].name);
      histroyAPI.push(currentMenu[0].path);
    }
  }

  function getClouds() {
    return ((window.adobeIMS?.isSignedInUser() && (isMyEvents || preferMyEvents)) ? myCloudEvents : cloudEvents).map((incident: any) => {
      return (
        <li key={incident.cloud.cloudId}>
          <span
            className="cloud-name clearfix"
            data-tab="{incident.cloud.cloudId}"
            tabIndex={0}
            role="button"
            aria-label={`Go to ${incident.cloud.cloudName}`}
            onClick={() => {
              redirectCloud(incident.cloud.cloudId);
            }}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                redirectCloud(incident.cloud.cloudId);
              }
            }}
          >
            <i className={`icon ${incident.icon}`}></i>
            <span className="text">{incident.cloud.cloudName}</span>
          </span>
          {
            incident.statusDetails.map((status: any, index: number) => {
              return (
                <span key={index} className="status"><i className={status.eventType.includes(EventType.maintenance) ? `event-icon ${status.eventType}` : `event-icon ${status.eventType.split("_")[0]}`}></i><span className="cloud-message">{status.eventString}</span></span>
              );
            })
          }
        </li>
      );
    })
  }

  function renderEventNavHelp(index: any, item: any, cloudindex?:any, foundFirstEvent?:any) {
    var indices = findMobileNavCloudIndex(currentCloudEvents);
    if ((!isMobile&&index === 0 ) || (isMobile && indices[0] === cloudindex && indices[1] === index)) {
      var eventTypes: any;
      if (navState === 4) {
        eventTypes = getEventTypes();
          if (!isMobile && eventTypes.length > 0 && eventTypes.includes((item._type).toLowerCase())) {
            if ((item._type) === eventTypes[0]) {
              return (<>
                <Navigation eventExpand={navEventExpand} eventState={item._type} isMobile={isMobile} eventType={item.eventType} navstate={setNavState} navstep={navState} rightalign={true} setExpand={setNavEventExpand}/>
              </>);
            }
          }else if(isMobile){
            return (<>
                <Navigation eventExpand={navEventExpand} eventState={item._type} isMobile={isMobile} eventType={item.eventType} navstate={setNavState} navstep={navState} rightalign={true} setExpand={setNavEventExpand}/>
              </>);
          }
      }
      if (navState === 5) {
        eventTypes = getEventTypes();
        if (!isMobile && eventTypes.length > 0 && eventTypes.includes((item._type).toLowerCase())) {
          if (item._type === eventTypes[0]) {
         
            return (<>
              <Navigation eventExpand={navEventExpand} isMobile={isMobile} eventState={item._type}eventType={item.eventType} navstate={setNavState} navstep={navState} rightalign={true} setExpand={setNavEventExpand}/>
            </>);
          }
        }
        else if(isMobile){
              return (<>
                  <Navigation eventExpand={navEventExpand} isMobile={isMobile} eventState={item._type} eventType={item.eventType} navstate={setNavState} navstep={navState} rightalign={true} setExpand={setNavEventExpand}/>
                </>);
        }
      }
    }
  }

  function getEventTypes() {
    const issueTypes = [EventType.major, EventType.minor, EventType.potential];
    const maintenanceTypes = [EventType.maintenance];
    var issueExist = false, maintenanceExist = false;
    var eventTypes: any[] = [];
    events.forEach((event: any) => {
      if (event.eventType !== "global" && event.eventType !== "cloud" && event.eventType !== "product") {
        if (!issueTypes.some(item => eventTypes.includes(item)) && issueExist === false) {
          eventTypes.push(event.list[0]._type);
          issueExist = true;
        } else if (maintenanceTypes.includes(event.eventType) && !maintenanceTypes.some(item => eventTypes.includes(item)) && maintenanceExist === false) {
          eventTypes.push(event.list[0]._type);
          maintenanceExist = true;
        }
      }
    })
    return eventTypes;
  }
  function getEventTiles() {
    return events.map((incident: any, index1: any) => {
      return (
        <div key={index1}>
          {incident.list.map((item: any, index: any) => {
            return (
              <div key={index}>
                {
                  <EventTile 
                    event={item} 
                    key={index} 
                    isHistory={false} 
                    isSubscribed={Subscribed(item,subscriptions)} 
                    subscriptionLoading={loadingSubscription} 
                    error={subscriptionError} 
                    expandall={isExpanded} 
                    myevents={isMyEvents}
                    tourActive={navState > 0}
                  />
                }
                {renderEventNavHelp(index, item)}
              </div>
            );
          })}
        </div>
      );
    });
  }

  function getMergedSelfSubscriptions(subscriptionData?: any) {
    if (Array.isArray(subscriptionData)) {
      return subscriptionData;
    }
    if (subscriptionData) {
      return serviceRegistry.mergeOfferingsIntoProduct(subscriptionData);
    }
    return [];
  }

  function isUserEntitledAndSubscribed() {
    return (
      (subscriptions?.length) ||
      getMergedSelfSubscriptions(selfSubscription).length > 0 ||
      entitledProducts?.length
    );
  }

  // Whether the user has actual product subscriptions to review (matches the "Product
  // subscriptions" list on the Manage Subscriptions page). Deliberately excludes entitledProducts:
  // entitlements just mean the user owns/licenses a product (used to auto-recommend My Events),
  // not that they've subscribed to anything - so an entitled-but-unsubscribed user should be
  // told to create subscriptions, not to review ones that don't exist.
  function hasProductSubscriptions() {
    return getMergedSelfSubscriptions(selfSubscription).length > 0;
  }

  function isMyEventsRecommended() {
    return myEventsByType.some((incident: IncidentGroup) => incident.list.length);
  }

  function isMyCurrentCloudEventsRecommended() {
    return myCurrentCloudEvents.some((incident: IncidentGroup) => incident.list.length);
  }

  function isShowExpandAndCollapse() {
    // Show buttons when there are events, regardless of tour state
    if (isMyEvents) {
      return isMyEventsRecommended();
    } else {
      return events.some((incident: IncidentGroup) => incident.list.length);
    }
  }

  function getMyEventTiles() {
    if (
      (isUserEntitledAndSubscribed() && isMyEventsRecommended()) ||
      isFilterRequest
    ) {
      if (myEventsByType?.length) {
        return myEventsByType.map((incident: any, indexType: number) => {
          return (
            <div key={indexType}>
              {incident.list.map((item: any, index: number) => {
                return (
                  <div key={index}>
                    {
                      <EventTile
                        event={item}
                        key={index}
                        isHistory={false}
                        isSubscribed={Subscribed(item,subscriptions)}
                        subscriptionLoading={loadingSubscription}
                        error={subscriptionError}
                        expandall={isExpanded}
                        myevents={isMyEvents}
                        tourActive={navState > 0}
                      />
                    }
                    {renderEventNavHelp(index, item)}
                  </div>
                );
              })}
            </div>
          );
        });
      } else {
        const message = appliedFilter ? locales.no_event_found : "";
        if (message && statusMessage !== message) {
          setStatusMessage(message);
        }
        return appliedFilter ? <p className="no-events"><i className="event-icon available"></i> {locales.no_event_found}</p> : ""
      }
    } else if (hasProductSubscriptions() && !isMyEventsRecommended()) {
      return getReviewSubscriptionScreen();
    } else {
      return getaddSubscriptionScreen();
    }
  }

  function getaddSubscriptionScreen() {
    return (
      <EmptyMyEventsMessage
        title={locales.subscribe}
        message={locales.my_event_logged_in_empty_sub_entlmnt}
        type="1"
        buttonText={locales.subscribe}
        titleRole="heading"
        titleLevel={2}
      ></EmptyMyEventsMessage>
    );
  }
  function getReviewSubscriptionScreen() {
    return (
      <EmptyMyEventsMessage
        title={locales.my_events_empty_events_header}
        message={locales.my_events_empty_events}
        type="1"
        buttonText={locales.manage_subscriptions}
      ></EmptyMyEventsMessage>
    );
  }

  function getEmptyLoginScreen() {
    return (
      <EmptyMyEventsMessage
        title={locales.my_events_sign_in_button}
        message={locales.my_events_anonymous_user_sign_in}
        buttonText={locales.my_events_sign_in_button}
        type="2"
      />
    );
  }

  function getMobileEventString(incident: any) {
    let count: number = 0, map_string: string = "", mainEventCount: number, eventString: string;
    let mainEventType = incident.status[0].eventType;
    incident.statusDetails.forEach((eventType: any) => {
      if (eventType.type !== mainEventType) {
        count += 1;
      }
    })
    if (count && !mainEventType.includes("resolved")) {
      mainEventCount = incident.statusDetails.filter((statuslist: any) => statuslist.type === mainEventType).length;
      eventString = mainEventCount > 1 ? "_events" : "_event";
      map_string = locales[(mainEventType) + eventString];
      if (map_string) {
        map_string = map_string.replace(`{${mainEventType}Count}`, mainEventCount.toString())
          + locales.other_incidents_banner.replace("{otherIncidentsCount}", count);
      }
    } else if (count && mainEventType.includes("resolved")) {
      map_string = incident.status[0].eventString + locales.other_incidents_banner.replace("{otherIncidentsCount}", count);
    }
    else {
      map_string = incident.status[0].eventString;
    }
    return map_string;
  }

  function findMobileNavCloudIndex(navEvents:any){
    var cloudindex;
    var eventindex;
    var found = false;
    var type;
    navEvents.forEach((eventObj:any, index:any)=>{
      if (found) return;
      eventObj.list.forEach((event:any, indexele:any)=>{
        if (found) return;
        if(event.eventType!=="Global" && event.eventType!=="Product" && event.eventType!=="Cloud"){
          cloudindex = index;
          eventindex =  indexele;
          found=true;
          type=event._type;
        }
      })
    })
    return [cloudindex,eventindex,type];
  }

  function getEventsMobileTile(currentCloudEvents: any) {
    return currentCloudEvents.map((incident: any, index: any) => {
      return (
        <div className="mobile-cloud-section" key={index}>
          <div className="mobile-cloud-header">
            <span
              className="cloud-name clearfix"
              data-tab="{incident.cloud.cloudId}"
              tabIndex={0}
              role="button"
              aria-label={`Go to ${incident.cloud.cloudName}`}
              onClick={() => {
                redirectCloud(incident.cloud.cloudId);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  redirectCloud(incident.cloud.cloudId);
                }
              }}
            >
              <i className={`icon ${incident.icon}`}></i>
              <span className="text">{incident.cloud.cloudName}</span>
              <span className="status-mobile">
                <i className={`event-icon ${incident.status[0].eventType.split("_")[0]}`}></i>
                <i className={`event-color ${incident.status[0].eventType.split("_")[0]}`}></i>
                {getMobileEventString(incident)}
              </span>
            </span>
          </div>
          {incident.list.length ? (
            <ul className="event-list mobile-tiles">
              {incident.list.map((item: any, listindex: any) => (
                <li key={listindex}>
                  <EventTile
                    event={item}
                    isHistory={false}
                    isSubscribed={Subscribed(item, subscriptions)}
                    subscriptionLoading={loadingSubscription}
                    error={subscriptionError}
                    expandall={isExpanded}
                    tourActive={navState > 0}
                  />
                  {renderEventNavHelp(listindex, item, index)}
                </li>
              ))}
            </ul>
          ) : null}
          <hr />
        </div>
      );
    });
  }

  function getEventSeperator() {
    return (
      <MyEventsToggle
        isOn={isMyEvents || preferMyEvents}
        onChange={(enabled) => (enabled ? handleClickMyEvents() : handleClickAllEvents())}
        allLabel={locales.all}
        label={locales.my_events}
        infoText={locales.my_events_icon_info}
        tooltipId="main"
        tooltipExpanded={tooltipExpanded}
        onTooltipShow={() => setTooltipExpanded(true)}
        onTooltipHide={() => setTooltipExpanded(false)}
        switchId="my-events-tab"
        ariaControls="events-content"
        onShowingText={locales.showing_my_events}
        offShowingText={locales.showing_all_events}
        rightContent={isShowExpandAndCollapse() ? (
          <div className={`expand-collapse ${navState > 0 ? 'disabled' : ''}`}>
            <div className="toggle-buttons">
              <button
                className={!isExpanded ? 'active' : ''}
                onClick={() => {
                  if (navState === 0) {
                    setIsExpanded(false);
                  }
                }}
                tabIndex={0}
                aria-pressed={!isExpanded}
                aria-expanded={false}
                onKeyDown={e => {
                  if ((e.key === 'Enter' || e.key === ' ') && navState === 0) {
                    e.preventDefault();
                    setIsExpanded(false);
                  }
                }}
              >
                {locales.incident_toggle_collapse}
              </button>
              <button
                className={isExpanded ? 'active' : ''}
                onClick={() => {
                  if (navState === 0) {
                    setIsExpanded(true);
                  }
                }}
                tabIndex={0}
                aria-pressed={isExpanded}
                aria-expanded={true}
                onKeyDown={e => {
                  if ((e.key === 'Enter' || e.key === ' ') && navState === 0) {
                    e.preventDefault();
                    setIsExpanded(true);
                  }
                }}
              >
                {locales.incident_toggle_expand}
              </button>
            </div>
          </div>
        ) : null}
      />
    )
  }

  function getMyEventsMobileTile() {
    if (!isFilterRequest) {
      if (isUserEntitledAndSubscribed() && isMyCurrentCloudEventsRecommended()) {
        return getEventsMobileTile(myCurrentCloudEvents);
      } else if (hasProductSubscriptions() && !isMyCurrentCloudEventsRecommended()) {
        return getReviewSubscriptionScreen();
      } else {
        return getaddSubscriptionScreen();
      }
    } else {
      return getEventsMobileTile(myCurrentCloudEvents)
    }
  }

  function getMobileTiles() {
    return (
      <>
        <div className="col-md-12 clearfix">
          {getEventSeperator()}
         
        </div>
        {navState === 3 ? <Navigation setExpand={setNavEventExpand} navstate={setNavState} navstep={navState} type={isMyEvents?findMobileNavCloudIndex(myCurrentCloudEvents)[2]:findMobileNavCloudIndex(currentCloudEvents)[2]}eventIndex={isMyEvents?findMobileNavCloudIndex(myCurrentCloudEvents)[0]:findMobileNavCloudIndex(currentCloudEvents)[0]} mobilenav={true}/> : <></>}
        
        {
          isMyEvents ? window.adobeIMS.isSignedInUser() ? isMyEventsLoading ? <Spinner /> : subscriptionError ? <div className="error-info"><p>{parse(locales.api_error_overview)}</p></div> : getMyEventsMobileTile() : getEmptyLoginScreen() : getEventsMobileTile(currentCloudEvents)
        }
      </>
    )
  }

  function onChange(e: any) {
    if (!e || e.length === 0) {
      setAppliedFilter(false);
      window.sessionStorage.setItem('search', JSON.stringify([]));
      setcurrentCloudEvents(eventService.getOnGoingEventsByCloud() as any);
      setEvents(filterOngoingCanceledMaitenaceEvents(eventService.getOnGoingEventsByType()) as any);
      setIsFilterRequest(false);
      return;
    }
    
    const quickActions = e.filter((option: any) => option.type === "quick_action");
    
    if (quickActions.length > 0) {
      const quickAction = quickActions[quickActions.length - 1];
      handleQuickAction(quickAction.value);
      
      // Remove quick actions from the dropdown selection
      if (dropdownRef.current) {
        setTimeout(() => {
          try {
            const regularOptions = e.filter((option: any) => option.type !== "quick_action");
            
            const select = dropdownRef.current as any;
            if (select && select.setValue) {
              // Force an error by calling setValue with invalid data
              select.setValue(regularOptions); // This should cause an error
            }
          } catch (error: any) {
            console.error("Error setting dropdown value:", error);
            omega_capture(
              `Error setting dropdown value in onChange function: ${error.message || error.toString()}`, // Use actual error message
              "personalization",
              "error"
            );
          }
        }, 0);
      }
      
      // If there are no other options selected, return early to avoid filter processing
      if (e.length === quickActions.length) {
        return;
      }
    }
    
    // Filter out quick actions for further processing
    const filteredOptions = e.filter((option: any) => option.type !== "quick_action");
    
    if (filteredOptions.length === 0) {
      return;
    }
    
    setAppliedFilter(true);
    let selectedOptions: any = [];
    
    filteredOptions.forEach((event: any) => {
      selectedOptions.push(event.value);
      OMEGA.init().updateAndTrack("event", [{
        ...eventDefaultValue,
        element: "Search dropdown",
        action: "change",
        type: "List items",
        name: event.value,
        attributes: {
          name: event.value
        },
        widget: {
          name: event.type ? event.type + " search" : "Search term used",
          type: "form"
        },
        search: {
          term: event.value
        },
        feature: "Search in Overview page dropdown"
      }]);
    });
    
    window.sessionStorage.setItem('search', JSON.stringify(selectedOptions));
    
    let filteredEventsMobile = eventService.getOnGoingEventsByCloud(undefined, undefined, selectedOptions);
    setcurrentCloudEvents(filteredEventsMobile as any);
    
    let filteredEvents = filterOngoingCanceledMaitenaceEvents(eventService.getOnGoingEventsByType(undefined, undefined, selectedOptions));
    setEvents(filteredEvents as any);
    
    setIsFilterRequest(selectedOptions.length > 0);
    
    if (window.adobeIMS?.isSignedInUser()) {
      window.adobeIMS?.getProfile().then((profile: any) => {
        let extractedSubscription = getMergedSelfSubscriptions(selfSubscription),
          entitlements: any[] = subscriptionService.getImsEntitlementProducts(serviceRegistry.getServiceCodeMap(), profile),
          _myEvents = eventService.getMyEvents(subscriptions, extractedSubscription, entitlements);
        
        if (_myEvents?.length) {
          setMyEvents(_myEvents);
        }
        
        let filteredMyEventsByType = filterOngoingCanceledMaitenaceEvents(eventService.getOnGoingEventsByType(undefined, undefined, selectedOptions, _myEvents)),
          filteredMyEventsByCloud = eventService.getOnGoingEventsByCloud(undefined, undefined, selectedOptions, _myEvents);
        
        setMyCurrentCloudEvents(filteredMyEventsByCloud);
        setEventsByType(filteredMyEventsByType);
      });
    }
  }

  const formatOptionLabel = (option: any) => {
    if (option.type === "quick_action") {
      return option.label;
    }
    
    if (option.productName) {
      return (
        <div className='dd-name'>
          <div>{option.label}</div>
          <div className='product-guide' style={{ fontSize: "11px", color: "#595959" }}>
            {option.productName}
          </div>
        </div>
      );
    }

    return (
      <div className='dd-name'>
        <div>{option.label}</div>
      </div>
    );
  }

  function selectDropdown() {
    const quickActionsGroupLabel = "Quick actions";

    /** Spoken by react-select's aria-live region (VoiceOver captions); needs group text because live region uses getOptionLabel, not row aria-label. */
    const searchOptionAssistiveLabel = (data: any): string => {
      if (data.__isNew__) {
        return `${locales.search_text} ${data.label}`.trim();
      }
      let name = data.label ?? "";
      if (data.productName) {
        name = `${name}, ${data.productName}`;
      }
      if (data.groupLabel) {
        return `${name} from ${data.groupLabel} group`;
      }
      return name;
    };

    const searchAriaLiveMessages = {
      onFocus: (props: any) => {
        const { context, focused, options, selectValue, isDisabled, isSelected } = props;
        const getArrayIndex = (arr: any[], item: any) => {
          if (!arr?.length) return "";
          // Flatten grouped options to get correct position
          const flat = arr.flatMap((g: any) => g.options ? g.options : [g]);
          const pos = flat.findIndex((o: any) => o.value === item.value) + 1;
          const size = flat.length;
          return pos > 0 ? `${pos} of ${size}` : "";
        };
        if (context === "value" && selectValue && focused) {
          const ann = searchOptionAssistiveLabel(focused);
          return `value ${ann} focused, ${getArrayIndex(selectValue, focused)}.`;
        }
        if (context === "menu" && focused) {
          const disabled = isDisabled ? " disabled" : "";
          const status = `${isSelected ? "selected" : "focused"}${disabled}`;
          const ann = searchOptionAssistiveLabel(focused);
          return `option ${ann} ${status}, ${getArrayIndex(options, focused)}.`;
        }
        return "";
      },
      onChange: (props: any) => {
        const { action, isDisabled, label } = props;
        const option = props.option ?? props.removedValue;
        const ann = option ? searchOptionAssistiveLabel(option) : label ?? "";
        switch (action) {
          case "deselect-option":
          case "pop-value":
          case "remove-value":
            return `option ${ann}, deselected.`;
          case "select-option":
            return isDisabled
              ? `option ${ann} is disabled. Select another option.`
              : `option ${ann}, selected.`;
          default:
            return "";
        }
      },
    };

    let filterOption: any[] = [{
      label: locales.products,
      options: allProducts.products.map((product: Product) => {
        return {
          value: product.id,
          label: product.name,
          type: locales.products,
          groupLabel: locales.products,
        };
      }),
    },
    {
      label: locales.product_offering,
      options: allProducts.offerings.map((offering: any) => {
        return {
          value: offering.id,
          label: offering.name,
          productName: serviceRegistry.getProductNameofOffer(offering.id),
          type: locales.product_offering,
          groupLabel: locales.product_offering,
        };
      }),
    }];
    
    // if (JSON.parse(SHOW_CHATBOT) && loggedIn && 
    //     (!JSON.parse(DARK_LAUNCH) || isUserAllowedForDarkLaunch)) {
      filterOption.unshift({
        label: quickActionsGroupLabel,
        className: "suggested-searches-group",
        options: [
          {
            value: "advanced_event_search",
            label: "Advanced Event search",
            type: "quick_action",
            groupLabel: quickActionsGroupLabel,
          }
        ]
      });
   // }
    
    const formatGroupLabel = (data: any) => (
      <div className="service-dd__group-heading" data-text={data.label}>
        {data.label}
      </div>
    );

    const SelectGroup = selectComponents.Group as React.FC<any>;
    const Group = (groupProps: any) => {
      const { innerProps, headingProps } = groupProps;
      const headingId = headingProps?.id as string | undefined;
      return (
        <SelectGroup
          {...groupProps}
          innerProps={{
            ...innerProps,
            ...(headingId ? { role: "group", "aria-labelledby": headingId } : {}),
          }}
        />
      );
    };

    const ClearIndicator = (props: any) => {
      const Clear = selectComponents.ClearIndicator as React.ComponentType<any>;
      return (
        <Clear
          {...props}
          innerProps={{
            ...props.innerProps,
            "aria-hidden": false,
            role: "button",
            tabIndex: 0,
            "aria-label": "Clear all selected options",
            onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                props.innerProps.onMouseDown?.(e as any);
              }
            },
          }}
        />
      );
    };

    const DropdownIndicator = (props: any) => {
      const Dropdown = selectComponents.DropdownIndicator as React.ComponentType<any>;
      return (
        <Dropdown
          {...props}
          innerProps={{
            ...props.innerProps,
            "aria-hidden": false,
            role: "button",
            tabIndex: 0,
            "aria-label": "Open dropdown menu",
            onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                props.innerProps.onMouseDown?.(e as any);
              }
            },
          }}
        />
      );
    };

    const Option = (props: any) => {
      const { data, isSelected, isFocused, innerProps, innerRef } = props;
      const optionRef = useRef<HTMLDivElement | null>(null);

      const setOptionRefs = (el: HTMLDivElement | null) => {
        optionRef.current = el;
        if (typeof innerRef === "function") {
          innerRef(el);
        } else if (innerRef != null) {
          (innerRef as React.MutableRefObject<HTMLDivElement | null>).current = el;
        }
      };

      // Scroll into view when focused
      useEffect(() => {
        if (isFocused && optionRef.current) {
          optionRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }, [isFocused]);

      if (data.type === "quick_action") {
        return (
          <div 
            ref={setOptionRefs}
            className={`suggested-search-option service-dd__option ${isFocused ? 'service-dd__option--is-focused' : ''} ${isSelected ? 'service-dd__option--is-selected' : ''}`}
            {...innerProps}
          >
            <div className="suggested-search-item">
              {data.label}
            </div>
          </div>
        );
      }

      return (
        <div 
          ref={setOptionRefs}
          className={`service-dd__option ${isFocused ? 'service-dd__option--is-focused' : ''} ${isSelected ? 'service-dd__option--is-selected' : ''}`}
          {...innerProps}
        >
          {formatOptionLabel(data)}
        </div>
      );
    };
    
    return (
      <CreatableSelect
        ref={(ref: ElementRef<any>) => {
          if (ref) {
            dropdownRef.current = ref;
          }
        }}
        inputId="search-products-services-events"
        isMulti
        classNamePrefix="service-dd"
        options={filterOption}
        onChange={onChange}
        isDisabled={loadingSubscription}
        formatOptionLabel={formatOptionLabel}
        formatGroupLabel={formatGroupLabel}
        components={{ Group, Option, ClearIndicator, DropdownIndicator }}
        placeholder={locales.search_placeholder}
        noOptionsMessage={() => locales.search_no_results}
        formatCreateLabel={userInput => `${locales.search_text} ${userInput}`}
        ariaLiveMessages={searchAriaLiveMessages}
        maxMenuHeight={300}
        menuPosition="absolute"
        closeMenuOnScroll={false}
        styles={{
          multiValueRemove: (base, state) => ({
            ...base,
            ':focus': {
              backgroundColor: '#D04423',
              borderRadius: '0 2px 2px 0',
            },
          }),
          clearIndicator: (base) => ({
            ...base,
            '& svg': {
              fill: '#595959',
            },
          }),
          dropdownIndicator: (base) => ({
            ...base,
            '& svg': {
              fill: '#595959',
            },
          }),
          option: (base, state) => ({
            ...base,
            ...(state.isFocused ? { outline: '2px solid #2680EB', outlineOffset: '-2px' } : {}),
          }),
        }}
      />
    );
  }

  function filterNavEvents(navevents:any){
    return navevents.filter((navEventItem: any)=> {return navEventItem.type !== EventType.announcement && !navEventItem.type.includes("resolved") && !navEventItem.type.includes("completed")} )
  }

  function filterResolvedevents(navevents:any){
    return navevents.filter((navEventItem: any)=> {return navEventItem.type.includes("resolved") || navEventItem.type.includes("completed")} )
  }

  function renderEventList() {
    if (error) {
      return (
        <div className="container">
          <div className="error-wrapper">
            <GenericError />
          </div>
        </div>
      );
    } else {
      if (isMobile) {
        HideFooter(false);
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="overview-mobile-list">
                {isMyEvents && subscriptionError ? <div className="error-info"><p>{parse(locales.api_error_overview)}</p></div> : ""}
                {loading ? <MyLoader ></MyLoader> : getMobileTiles()}
              </div>
            </div>
          </div>
        );
      }
      return (
        <div>
          {loading ? <div className="container" >
            <MyLoader></MyLoader>
            {HideFooter(true)}
          </div>
            :<>  {HideFooter(false)}
                <div className="container overview-wrapper">
             
              <section className="overview-list">
                <div className="row">
                  <div className="col-md-12">

                    <ul className="cloud-list clearfix">
                      {getClouds()}
                    </ul>

                  </div>
                </div>
              </section>
              {isMyEvents && subscriptionError ? <div className="error-info"><p>{parse(locales.api_error_overview)}</p></div> : ""}
              <div className="row">
                <div className="col-md-12 clearfix overview-tab">
                  {(events && events.length) || appliedFilter ? getEventSeperator() : ""}
                </div>
              </div>
              {navState === 3 ? <Navigation setExpand={setNavEventExpand} navstate={setNavState} navstep={navState} resolvedEvents={isMyEvents?filterResolvedevents(myEventsByType):filterResolvedevents(events)}events={isMyEvents?filterNavEvents(myEventsByType):filterNavEvents(events)}/> : <></>}
              <div id="events-content" role="tabpanel" aria-labelledby="my-events-tab">
                {((events && events.length) || appliedFilter)
                  ? window.adobeIMS.isSignedInUser() ? isMyEvents ? isMyEventsLoading ? <Spinner /> : subscriptionError ? <div className="error-info"><p>{parse(locales.api_error_overview)}</p></div> : getMyEventTiles()
                    : events && events.length > 0 ? getEventTiles() : appliedFilter ? (() => {
                      const searchMessage = "There are no events on your search. Would you like to try our Advanced Event search?";
                      if (statusMessage !== searchMessage) {
                        setStatusMessage(searchMessage);
                      }
                      return <p className="no-events"><i className="event-icon available"></i> There are no events on your search. Would you like to try our <button
                        className="link-style"
                        aria-label="Open Advanced Event search dialog"
                        aria-describedby="advanced-search-description"
                        onClick={() => {
                          handleQuickAction("advanced_event_search");
                        }}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleQuickAction("advanced_event_search");
                          }
                        }}
                      >Advanced Event search</button>?<span id="advanced-search-description" className="sr-only">Opens a dialog to search for events with advanced filters</span></p>;
                    })() : ""
                    : isMyEvents ? getEmptyLoginScreen() : events && events.length > 0 ? getEventTiles()
                      : appliedFilter ? (() => {
                        const message = locales.no_event_found;
                        if (statusMessage !== message) {
                          setStatusMessage(message);
                        }
                        return <p className="no-events"><i className="event-icon available"></i> {locales.no_event_found}</p>;
                      })() : ""
                  : ""
                }
              </div>
            </div></>


          }
        </div>
      );
    }
  }

  function initialNav() {
    return (<Navigation navstate={setNavState} navstep={navState} />);
  }

  function checkUserLoggedIn() {
    if(window.adobeIMS?.isSignedInUser()){
      window?.adobeIMS?.getProfile().then((profile: any) => {
        if(profile?.emailVerified === "true"){
          setLoggedIn(true);
          const allowlistArray = ALLOWLIST_USERS.split(',').map(email => email.trim().toLowerCase());
          if (allowlistArray.includes(profile?.email.toLowerCase())) {
            setIsUserAllowedForDarkLaunch(true);
          }
        }
      });
    }
  }

  function handleQuickAction(actionId: string) {
    if (!window.adobeIMS?.isSignedInUser()) {
      // Store the action to execute after login
      sessionStorage.setItem('pendingQuickAction', actionId);
      window.adobeid.redirect_uri = window.location.href;
      window.adobeIMS.signIn();
      return;
    }    

    // Execute the quick action for logged-in users
    executeQuickAction(actionId);
  }

  function executeQuickAction(actionId: string) {
    const windowWithFunctions = window as any;
    if (windowWithFunctions.setShowBotState) {
      windowWithFunctions.setShowBotState(true); 

      if (actionId === "advanced_event_search") {
        const ref = getButtonRef("findEvents");
        if (ref?.current) {
          ref.current.click();
        } else {
          // Not yet mounted — wait until it's registered
          onButtonRegistered("findEvents", (ref:any) => {
            ref.current?.click();
          });
        }
      }

      OMEGA.init().updateAndTrack("event", [{
        ...eventDefaultValue,
        element: `Quick Action - ${actionId}`,
        action: "click",
        type: "QuickAction",
        widget: {
          name: "virtual-assistant",
          type: "chatbot"
        },
        feature: "virtual assistant"
      }]);
    }
  }

  // Add tooltip to the chatbot icon
  useEffect(() => {
    // Function to add tooltip to chatbot icon
    const addTooltipToChatbotIcon = () => {
      const chatbotIconElement = document.querySelector('.chatbot-button');
      if (chatbotIconElement && !chatbotIconElement.querySelector('.tooltip')) {
        const tooltip = document.createElement('div');
        tooltip.className = 'tooltip';
        tooltip.textContent = 'Ask our assistant';
        chatbotIconElement.appendChild(tooltip);
      }
    };
    
    // Add tooltip initially
    addTooltipToChatbotIcon();
    
    // Set up a mutation observer to detect when the chatbot icon is added to the DOM
    // or when its class changes (to detect opening/closing)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Check if chatbot icon was added
          addTooltipToChatbotIcon();
        } else if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // Class changed - check if tooltip needs to be added/removed
          addTooltipToChatbotIcon();
        }
      });
    });
    
    // Start observing the document body for changes in DOM and attributes
    observer.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Clean up the observer when component unmounts
    return () => {
      observer.disconnect();
    };
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div>
      <div className="overview-container">
        <Banner isParentLoading={loading} showOnlyScheduledCanceledMaintenace={true} navstate={setNavState} isMyEventsSource={!!(window.adobeIMS?.isSignedInUser() && (isMyEvents || preferMyEvents))} cloudEvents={(window.adobeIMS?.isSignedInUser() && (isMyEvents || preferMyEvents)) ? myEvents : undefined} />
        {navState === 1 ? initialNav() : <></>}
        {navState === 2 ? <Navigation isMobile={isMobile} navstate={setNavState} navstep={navState} rightalign={true} events={events}/> : <></>}
        
  
        
        <div className={isMobile ? "" : "container"}>
          <div className="row">
            <div className={isMobile ? "col-md-12 " : "col-lg-3 offset-lg-9 col-md-4 offset-md-8"}>

              <div className={isMobile ? "mobile-dropdown search-field-wrapper" : "dropdown search-field-wrapper"}>
                <label htmlFor="search-products-services-events">
                  {locales.search_placeholder}
                </label>
                {selectDropdown()}
              </div>

            </div>
          </div>
        </div>
        {renderEventList()}
      </div>
      <div aria-live="polite" aria-atomic="true" className="sr-only">
        {statusMessage}
      </div>
    </div>
  )
}